// Serves images as AVIF → WebP → original via <picture>.
// For Unsplash URLs we append &fm=avif / &fm=webp. For anything else we
// fall through to a plain <img>.

function unsplashVariant(src, fm) {
  if (!src || typeof src !== "string" || !src.includes("images.unsplash.com")) return null;
  const sep = src.includes("?") ? "&" : "?";
  return `${src}${sep}fm=${fm}`;
}

export const SmartImage = ({
  src,
  alt,
  width,
  height,
  className = "",
  priority = false,
  ...rest
}) => {
  const avif = unsplashVariant(src, "avif");
  const webp = unsplashVariant(src, "webp");
  const loading = priority ? "eager" : "lazy";
  const fetchPriority = priority ? "high" : "auto";

  const img = (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      decoding="async"
      fetchPriority={fetchPriority}
      className={className}
      {...rest}
    />
  );

  if (!avif) return img;
  return (
    <picture>
      <source srcSet={avif} type="image/avif" />
      <source srcSet={webp} type="image/webp" />
      {img}
    </picture>
  );
};

export default SmartImage;
